const config = {
  name: import.meta.env.VITE_APP_NAME || window.APP_CONFIG?.VUE_APP_NAME || 'Chargebull',
  domain: import.meta.env.VITE_APP_DOMAIN || window.APP_CONFIG?.VUE_APP_DOMAIN || 'localhost:8081',
  backend: {
    baseUrl: import.meta.env.VITE_APP_BACKEND_BASE_URL || window.APP_CONFIG?.VUE_APP_BACKEND_BASE_URL || 'http://localhost:8080',
  },
};

export default config;
